import { injectable, inject } from 'inversify';
import HttpClient from '../../../http';
import {
  NPSServiceInterface,
  SendNPSRequest,
  SendNPSResponse,
  GetNPSByUserUuidRequest,
  GetNPSByUserUuidResponse,
} from './NPSService.types';
import { backendUrl } from 'src/config';

@injectable()
class NPSService implements NPSServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  public sendNPS({ user_uuid, ...data }: SendNPSRequest) {
    return this.client.getClient().post<SendNPSResponse>(
      `/nps/`,
      { user_uuid, ...data },
      {
        baseURL: backendUrl,
      }
    );
  }

  public getNPSByUserUuid({ user_uuid, from, to }: GetNPSByUserUuidRequest) {
    return this.client.getClient().get<GetNPSByUserUuidResponse>(`/nps/`, {
      baseURL: backendUrl,
      params: { user_uuid, from, to },
    });
  }
}

export default NPSService;
